import React from "react";
import CustomTable from "../../../../../components/common/Table/CustomTable";
import { renderDisburseCommissionColumn } from "../constants";
import { Modal, Button } from "antd";
import NumberFormat from "react-number-format";
import { CurrencyFormat } from "../../../../../components/helpers";

export default function ModalDisburseCommission({
  visible,
  data,
  loading,
  isAllChecked,
  onCheck,
  onCheckAll,
  handleCloseModalDisburse,
  onSubmit,
  submitting,
  tax,
  setTax,
  setFeeAdmin,
  feeAdmin,
  subtotal,
  total,
  handleReject,
  actionType,
}) {
  return (
    <Modal
      title={"Pilih Transaksi Untuk Cairkan Komisi"}
      visible={visible}
      onCancel={handleCloseModalDisburse}
      width={"60%"}
      centered
      footer={[
        <Button
          disabled={submitting}
          key="back"
          onClick={handleCloseModalDisburse}
          className="btn-modal btn-default"
          style={{ width: "15%" }}
        >
          Kembali
        </Button>,
        <Button
          disabled={submitting}
          key="submit"
          type={actionType === "process" ? "primary" : "danger"}
          onClick={actionType === "process" ? onSubmit : handleReject}
          className="btn-modal"
          style={{ width: "15%" }}
        >
          {actionType === "process" ? "Proses" : "Batalkan"}
        </Button>,
      ]}
    >
      <div className="py-2">
        <CustomTable
          columns={renderDisburseCommissionColumn(
            onCheck,
            onCheckAll,
            isAllChecked
          )}
          data={data}
          loading={loading}
          pagination={false}
          scrollX={800}
        />
        {actionType === "process" ? (
          <>
            <div className="d-flex justify-content-between pl-3 pr-5 mt-3">
              <div style={{ fontWeight: "600" }}>Subtotal</div>
              <div style={{ fontWeight: "600" }}>
                Rp {CurrencyFormat(subtotal)}
              </div>
            </div>
            <div className="d-flex justify-content-end mt-3 align-items-center">
              <div className="mr-2">Pajak (Rp)</div>
              <NumberFormat
                value={tax}
                isNumericString={true}
                onValueChange={(e) =>
                  setTax(e.floatValue == undefined ? 0 : e.floatValue)
                }
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix="Rp "
                style={{
                  height: 32,
                  border: "0.75px solid #DCDCDC",
                  width: 120,
                  paddingLeft: 6,
                  borderRadius: 6,
                  borderColor: "#DCDCDC",
                }}
              />
            </div>
            <div className="d-flex justify-content-end mt-3 align-items-center">
              <div className="mr-2">Biaya Admin</div>
              <NumberFormat
                value={feeAdmin}
                isNumericString={true}
                onValueChange={(e) =>
                  setFeeAdmin(e.floatValue == undefined ? 0 : e.floatValue)
                }
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix="Rp "
                style={{
                  height: 32,
                  border: "0.75px solid #DCDCDC",
                  width: 120,
                  paddingLeft: 6,
                  borderRadius: 6,
                  borderColor: "#DCDCDC",
                }}
              />
            </div>
            <div
              className="d-flex"
              style={{
                backgroundColor: "rgba(44, 70, 92, 0.14)",
                padding: 8,
                marginTop: 18,
                borderRadius: 10,
                justifyContent: "flex-end",
              }}
            >
              <div style={{ fontWeight: "500" }}>
                Total Komisi yang Harus Dicairkan :
              </div>
              <div style={{ fontWeight: "700", marginLeft: 3 }}>
                Rp {CurrencyFormat(total)}
              </div>
            </div>
          </>
        ) : (
          <div
            className="d-flex"
            style={{
              backgroundColor: "rgba(44, 70, 92, 0.14)",
              padding: 8,
              marginTop: 18,
              borderRadius: 10,
              justifyContent: "flex-end",
            }}
          >
            <div style={{ fontWeight: "500" }}>
              Total Komisi yang Akan Dibatalkan :
            </div>
            <div style={{ fontWeight: "700", marginLeft: 3 }}>
              Rp {CurrencyFormat(total)}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
